module.exports = __webpack_public_path__ + "static/media/DK4050_06.9773a3f9.jpg";